// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TextFormattingLinkView__input-f216ac {
  width: 300px;
  margin-inline-start: 6px;
}

.TextFormattingLinkView__divider-ce8800 {
  width: 1px;
  height: 24px;
  margin: 0px 3px;
  background-color: var(--base-20);
}`, "",{"version":3,"sources":["webpack://./src/components/TextFormattingInput/TextFormattingMenu/TextFormattingLinkView/TextFormattingLinkView.styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,wBAAA;AACF;;AAEA;EACE,UAAA;EACA,YAAA;EACA,eAAA;EACA,gCAAA;AACF","sourcesContent":[".input {\n  width: 300px;\n  margin-inline-start: 6px;\n}\n\n.divider {\n  width: 1px;\n  height: 24px;\n  margin: 0px 3px;\n  background-color: var(--base-20);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": `TextFormattingLinkView__input-f216ac`,
	"divider": `TextFormattingLinkView__divider-ce8800`
};
module.exports = ___CSS_LOADER_EXPORT___;
